import loadIntegrationsLogic from "./loadIntegrationsLogic";
import loadIntegrationsFailLogic from "./loadIntegrationsFailLogic";

export default [...loadIntegrationsLogic, ...loadIntegrationsFailLogic];
